import { createAvatar } from "../utils/avatarUtils";

// Employee data — profile (from /users/me) is source of truth;
// localStorage serves as an immediate fallback (populated at login).
export const useEmployeeProfileData = (profile) => {
  const _phone     = profile?.employeePhone         || localStorage.getItem("employeePhone")         || "";
  const _emergency = profile?.emergencyPhoneNumber  || localStorage.getItem("emergencyPhoneNumber")  || "";
  const _name      = profile?.employeeName          || localStorage.getItem("employeeName")          || "موظف غير محدد";

  const employeeData = {
    id:               profile?.infinityCode                  || localStorage.getItem("infinityCode")                  || "EMP001",
    name:             _name,
    position:         profile?.position ?? profile?.employeeType ?? localStorage.getItem("employeeType") ?? "--",
    department:       profile?.department ?? profile?.employeeType ?? localStorage.getItem("employeeType") ?? "--",
    email:            profile?.employeeEmail                 || localStorage.getItem("employeeEmail")                 || localStorage.getItem("email") || "employee@company.com",
    phone:            _phone ? "+20" + _phone : "--",
    address:          profile?.address                       || localStorage.getItem("address")                       || localStorage.getItem("location") || "--",
    joinDate:         profile?.hiringDate                    || localStorage.getItem("hiringDate")                    || null,
    employeeId:       profile?.infinityCode                  || localStorage.getItem("infinityCode")                  || "EMP001",
    manager:          profile?.firstLineManagerName          || localStorage.getItem("firstLineManagerName")          || "--",
    status:           profile?.employeeState                 || localStorage.getItem("employeeState")                 || "Active",
    avatar:           createAvatar(_name),
    birthDate:        profile?.DoB                           || localStorage.getItem("DoB")                           || null,
    nationalId:       profile?.nationalId                    || localStorage.getItem("nationalId")                    || "--",
    emergencyContact: _emergency ? "+20" + _emergency : "--",
    workLocation:     profile?.location                      || localStorage.getItem("location")                      || "--",
    firstLevelManager: profile?.firstLineManagerInfinityCode || localStorage.getItem("firstLineManagerInfinityCode") || "--",
  };

  return employeeData;
};
